export function normalizeCouponCode(code) {
  return (code || '').toString().trim().toUpperCase();
}

export function normalizeEmail(email) {
  return (email || '').toString().trim().toLowerCase();
}
